<div class="action-container" *appHasRole="['Admin', 'Manager', 'Preparer']">
  <div class="alert-action-wrapper">
    <app-ag-action-icon-button
      [iconClass]="alertIconClass"
      [numberOfAlerts]="numberOfNewAlerts"
      [disabled]="!numberOfAlerts"
      (action)="numberOfAlerts && onOpenAlerts()"
    />
  </div>

  <app-ag-action-icon-button
    iconClass="ic-notes-16"
    (action)="onOpenNotes()"
  />

  <app-ag-action-icon-button
    iconClass="ic-eye-16"
    (action)="onOpenTrustProfile()"
  />

  <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown d-inline-flex">
    <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

    <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
      <button ngbDropdownItem class="dropdown-item" (click)="onAppointAccountManager()">
        <span>Appoint Account Manager</span>
      </button>

      <button ngbDropdownItem class="dropdown-item" (click)="onExportTrustProfile()">
        <span>Download Trust Profile</span>
      </button>
    </div>
  </div>
</div>
